import { NetworkStatus } from "@apollo/client";
import { useMediaQuery } from "@mui/material";
import { FlaskIcon } from "@phosphor-icons/react/dist/csr/Flask";
import { DraftsLink } from "../../components";
import { DataLoader, EmptyContainer, LoadingContainer, SuccessContainer } from "../../components/DataLoader";
import { InfiniteScrollContainer } from "../../components/InfiniteScrollContainer";
import { CountDisplay } from "../../components/ui/CountDisplay";
import { RunList } from "../../components/ui/RunList";
import { SkeletonTestRunItem, SkeletonTestRuns } from "../../components/ui/skeletons";
import { BaseWelcomeMessage } from "../../components/WelcomeMessage";
import { TEST_RUNS_SUPPORT } from "../../constants/externalLinks";
import { TEST_RUNS_QUERY } from "../../graphql";
import type { Flow } from "../../graphql/types";
import "./TestRuns.css";

const PAGE_SIZE = 10;

const TestRuns = () => {
  const variables = {
    first: PAGE_SIZE,
  };
  const lg = useMediaQuery("(min-width:991px)");

  return (
    <InfiniteScrollContainer
      first={PAGE_SIZE}
      className={"testRuns-browser"}
      query={TEST_RUNS_QUERY}
      variables={variables}
      nodeName="flows"
      data-cy="infinite-scroll"
    >
      {({ loading, error, results, hasResults, isLoadingMore, networkStatus }) => {
        const testRunCounts = results ? results.length : 0;
        return (
          <DataLoader
            loading={loading && !isLoadingMore && networkStatus !== NetworkStatus.refetch}
            error={error}
            success={hasResults}
            defaults={{ small: false }}
          >
            <LoadingContainer>
              <SkeletonTestRuns rows={PAGE_SIZE} />
            </LoadingContainer>
            <EmptyContainer>
              <NoTests />
            </EmptyContainer>
            <SuccessContainer>
              <CountDisplay count={testRunCounts} entity="test" testLabel="test-count-top" sticky={false} />
              <RunList entries={(results ?? []) as Flow[]} bigSize={lg} />
              {isLoadingMore && <SkeletonTestRunItem />}
            </SuccessContainer>
          </DataLoader>
        );
      }}
    </InfiniteScrollContainer>
  );
};

const NoTests = () => (
  <div className="TestRuns" data-cy="welcome-test-runs">
    <BaseWelcomeMessage icon={FlaskIcon} title={"Welcome to Test Runs!"} supportDocsLink={TEST_RUNS_SUPPORT}>
      Create a new Test Run to view results here. Navigate to the <DraftsLink /> and select a draft to test.
    </BaseWelcomeMessage>
  </div>
);

export { TestRuns };
